import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PieChart from './PieChart';
import CallsByAgent from './CallsByAgent';
import RecentSection from './RecentSection';
import { Divider } from 'semantic-ui-react';
import userDashboardActions from 'actions/user_dashboard';
import { useSearchParams } from 'react-router-dom';

export default function PhoneSystemDashboard({ startTime, endTime }) {

  const [params] = useSearchParams();

  const startParams = params.get("start")
  const endParams = params.get("end")

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(userDashboardActions.getCallHistoryReport({ start_time: startParams || startTime, end_time: endParams || endTime }))
  }, [dispatch, startTime, endTime, startParams, endParams])

  return (
    <React.Fragment>
      <PieChart start_time={startParams || startTime} end_time={endParams || endTime} />
      <CallsByAgent start_time={startParams || startTime} end_time={endParams || endTime} />
      <Divider />
      <RecentSection />
    </React.Fragment>
  )
}
